import tw from 'tailwind-styled-components'

const Label = tw.label`
block 
font-semibold
text-xs
text-darkGray
truncate
pb-1
`
interface InputTextAreaProps {
  noBorder?: boolean;
  error?: boolean;
}

const InputTextArea = tw.textarea<InputTextAreaProps>`
block 
w-full 
${props => props.noBorder ? 'border-none' : 'border'} 
${props => props.error ? 'border-inputBorder' : 'border-errorText'} 
px-4
h-[38px]
text-[16px]
font-normal
outline-gray-200
rounded-lg
py-3
text-darkGray
text-[15px]
ring-0
focus:ring-0
focus:border
focus:border-inputBorder
resize-none
::placeholder {
}
`

const ErrorText = tw.span`
text-errorText
text-xs
absolute
-bottom-[17px]
`

const InputLength = tw.span`
absolute
text-xs
-bottom-[17px]
right-0
text-darkGray/80
`

export { Label, InputTextArea, ErrorText, InputLength }
